import {gql} from "@apollo/client/core";
import {CartProductFragment} from "../../../checkout/graphql/fragments/cart-product/cart-product-fragment";
import {CartProductGroupFragment} from "../../../checkout/graphql/fragments/cart-product/cart-product-group-fragment";

export const GetWelcomeKits = gql`
    query GetWelcomeKits
    {
        getWelcomeKits {
            ...CartProductFragment
        }
    }
    ${CartProductFragment}
`;

export const GetRecommendedProducts = gql`
    query GetRecommendedProducts($productId: Int, $usanaId: String) {
        getRecommendedProducts(productId: $productId, usanaId: $usanaId) {
            ...CartProductFragment
        }
    }
    ${CartProductFragment}
`;

export const GetCartProductGroups = gql`
    query GetCartProductGroups($usanaIds: [String]) {
        getCartProductGroups(usanaIds: $usanaIds) {
            ...CartProductGroupFragment
        }
    }
    ${CartProductGroupFragment}
`;
export const GetCartPDP = gql`
    query GetCartPDP($usanaId: String, $readableUrl: String) {
        getCartPDP(usanaId: $usanaId, readableUrl: $readableUrl) {
            ...CartProductGroupFragment
        }
    }
    ${CartProductGroupFragment}
`;
